import ResultHistoryTable from "./StatisticTable";
import React from "react";
import DrawingResult from "./DrawingResult";

export default () => {
    return <div className="col-9 no-padding-div none-select">
        <div className="wrap-lotto5-top col no-padding-div">
            <div className="lotto5-play-main">
                <DrawingResult/>
                <ResultHistoryTable/>
            </div>
        </div>
    </div>

}